<template>
    <div>
        <v-progress-linear v-if="isLoading" indeterminate color="primary" class="mb-5" />

        <template v-else>
            <v-tabs v-model="metaTab" v-if="platformMetaFields.length > 0">
                <v-tab v-for="tab in tabs" :key="tab.key">
                    {{ tab.label }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="metaTab">
                <v-tab-item v-for="tab in tabs" :key="tab.key">
                    <v-simple-table light>
                        <thead>
                            <tr>
                                <th width="40%">Key</th>
                                <th width="60%">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="meta in tab.fields" :key="meta.key">
                                <td>
                                    <div><strong :title="meta.type">{{ meta.key }}</strong></div>

                                </td>
                                <td class="py-2">
                                    <div class="text--primary mb-1">
                                        {{ meta.description }}
                                    </div>
                                    <div v-if="meta.type=='switch'" class="text--secondary text-xs">
                                        <code>On/Off</code>
                                    </div>
                                    <div v-else-if="meta.hint" class="text--secondary">
                                        <code class="text-xs">Ex: {{ meta.hint }}</code>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-tab-item>
            </v-tabs-items>
        </template>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'

export default {
    props: {
        integrationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            metaTab: 0,
            platformMetaFields: [],
            globalMetaFields: []
        }
    },
    computed: {
        tabs() {
            const metaFields =[
                {
                    key: 'global',
                    label: 'Global Settings',
                    fields: this.globalMetaFields
                }
            ];

            if (this.platformMetaFields.length > 0) {
                metaFields.unshift({
                    key: 'platform',
                    label: 'Platform Settings',
                    fields: this.platformMetaFields
                });
            }

            return metaFields;
        }
    },
    created() {
        this.getAllAvailableMetaFields()
    },
    methods: {
        getAllAvailableMetaFields() {
            this.isLoading = true

            this.$http
                .get(`/api/integrationmetas/available-meta-fields/${this.$route.params.id}?merged=false`)
                .then(({ data }) => {
                    this.platformMetaFields = data.platform
                    this.globalMetaFields = data.global
                })
                .catch(() => {
                    EventBus.$emit('show-error', 'Unable to load available meta fields')
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>